module.exports = __webpack_public_path__ + "img/U1F383.79685655.png";